import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FinderVehicleCondition } from '../../../../../../api/types';

const useFinderVehicleConditionOptions = () => {
    const { t } = useTranslation('moduleDetails');

    return useMemo(
        () => [
            {
                label: t('moduleDetails:explanations.finderVehicleCondition.new'),
                value: FinderVehicleCondition.New,
            },
            {
                label: t('moduleDetails:explanations.finderVehicleCondition.preowned'),
                value: FinderVehicleCondition.Preowned,
            },
            {
                label: t('moduleDetails:explanations.finderVehicleCondition.porscheApproved'),
                value: FinderVehicleCondition.PorscheApproved,
            },
        ],
        [t]
    );
};

export default useFinderVehicleConditionOptions;
